import { useExperimentParam } from 'src/utils/experimentNew'
import { Experiments } from '../constants'

type Variant = 'control' | 'treatment'

const EXPERIMENT_KEY = Experiments.ContestV2

export function useContestV2Experiment() {
  const variant = useExperimentParam<Variant>(EXPERIMENT_KEY)

  return {
    variant,
    isV2: variant === 'treatment',
  }
}
